import { Monitor, MonitorPlay, Video } from 'lucide-react'
import { MriButton } from '@mriqbox/ui-kit'
import { CopyButton } from '@/components/CopyField'
import { roomLinkFor } from '@/lib/format'
import { cameraUnavailableMessage, screenShareUnavailableMessage } from '@/lib/screenCapture'

export interface EmptyStageProps {
    code: string
    canShare: boolean
    canUseCamera: boolean
    onShare: () => void
    onCamera: () => void
}

export function EmptyStage({ code, canShare, canUseCamera, onShare, onCamera }: EmptyStageProps) {
    return (
        <div className="flex flex-col items-center gap-4 text-center">
            <span className="flex h-20 w-20 items-center justify-center rounded-2xl border border-border/70 bg-card/70">
                <Monitor className="h-8 w-8 text-muted-foreground" />
            </span>
            <div>
                <h2 className="text-lg font-bold text-foreground">Ninguem esta compartilhando ainda</h2>
                <p className="mt-1 max-w-sm text-sm text-muted-foreground">
                    Chame alguem com o link da sala, ou comece voce — pela tela ou pela camera.
                </p>
            </div>
            <div className="flex items-center gap-2">
                {/* Sem title aqui o botao desabilitado ficava mudo — quem tentava
                    compartilhar de http num IP de rede local nao sabia o porque. */}
                <MriButton
                    onClick={onShare}
                    disabled={!canShare}
                    title={canShare ? undefined : (screenShareUnavailableMessage() ?? undefined)}
                >
                    <MonitorPlay className="mr-2 h-4 w-4" />
                    Compartilhar tela
                </MriButton>
                <MriButton
                    variant="secondary"
                    onClick={onCamera}
                    disabled={!canUseCamera}
                    title={canUseCamera ? undefined : (cameraUnavailableMessage() ?? undefined)}
                >
                    <Video className="mr-2 h-4 w-4" />
                    Camera
                </MriButton>
                <CopyButton value={roomLinkFor(code)} label="Copiar link" />
            </div>
        </div>
    )
}
